<template>
    <TourLayout
        :config="config"
        show-skip-button
        @action-completed="onBiometricAction"
        @action-skipped="onSkipAction"
    >
        <template #description>
            {{ description }}
        </template>

        <div class="w-full flex justify-center items-center flex-1">
            <svg
                width="180"
                height="180"
                viewBox="0 0 180 180"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="shape-brand-subtle"
            >
                <path
                    d="M6 48V27C6 21.4305 8.21249 16.089 12.1508 12.1508C16.089 8.21249 21.4305 6 27 6H48M6 132V153C6 158.57 8.21249 163.911 12.1508 167.849C16.089 171.788 21.4305 174 27 174H48M132 6H153C158.57 6 163.911 8.21249 167.849 12.1508C171.788 16.089 174 21.4305 174 27V48M132 174H153C158.57 174 163.911 171.788 167.849 167.849C171.788 163.911 174 158.57 174 153V132M58.5 69H58.605M121.5 69H121.605M63.75 121.5C67.1717 124.992 71.2559 127.767 75.7633 129.661C80.2708 131.555 85.1108 132.53 90 132.53C94.8892 132.53 99.7292 131.555 104.237 129.661C108.744 127.767 112.828 124.992 116.25 121.5"
                    stroke="currentColor"
                    stroke-width="12"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </TourLayout>
</template>

<script setup>
    import { biometric } from '@/services/biometric'
    import { useTourStore } from '@/stores/tour'
    import TourLayout from './TourLayout.vue'

    const emit = defineEmits(['action-skipped', 'action-completed'])

    const versionStore = useVersionStore()
    const { snackbar } = useSnackbars()
    const tourStore = useTourStore()

    const { version } = storeToRefs(versionStore)

    const props = defineProps({
        config: Object,
    })

    const biometryType = ref(null)

    const primaryColor = computed(() => get(version.value, 'primary_color'))

    const description = computed(() => {
        return props.config.layout.description.replace('{biometryType}', biometryType.value)
    })

    const icon = computed(() => {
        switch (biometryType.value) {
            case 'Biometric Login':
            case 'Iris Authentication':
            case 'Face Authentication':
            case 'Face ID':
                return 'scan-smiley'
            case 'Fingerprint Authentication':
            case 'Touch ID':
                return 'fingerprint'
            default:
                return 'scan-smiley'
        }
    })

    const onBiometricAction = async () => {
        tourStore.handleAction(props.config.action_type, false)
        await biometric.authenticate().then(() => {
            biometric.setEnabled(true)
        }).catch(async () => {
            await biometric.setEnabled(false)
            snackbar({
                message: `Failed to enable ${await biometric.biometryType()}`,
                type: 'error',
            })
        })
        emit('action-completed', true)
    }

    const onSkipAction = () => {
        tourStore.handleAction(props.config.action_type, true)
        emit('action-skipped')
    }

    onBeforeMount(async () => {
        biometryType.value = await biometric.biometryType()
    })
</script>
